
export const requiredValidation=[
    { required: true, message:'Field is required' }, 
];